"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Popper_1 = require("@seaweb/coral/components/Popper");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var TipReference = function (_a) {
    var children = _a.children;
    var ref = Popper_1.usePopperReference().ref;
    return react_1.cloneElement(children, { ref: useForkRef_1.default(children.ref, ref) });
};
exports.default = TipReference;
